<template>
    <div class="faq-element" role="listitem" :class="{ 'element-open': faqOpen }">
        <button
            type="button"
            class="button-toggle"
            :aria-expanded="faqOpen"
            :aria-controls="'faq-answer-' + _uid"
            :id="'faq-question-' + _uid"
            @click="faqToggleButton"
        >
            <span class="button-title">{{ title }}</span>
            <svg class="button-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M16.585 8.58505L12 13.1701L7.415 8.58505L6 10.0001L12 16.0001L18 10.0001L16.585 8.58505Z" />
            </svg>
        </button>
        <div v-show="faqOpen" :id="'faq-answer-' + _uid" class="element-text" role="region" :aria-labelledby="'faq-question-' + _uid">
            {{ text }}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FaqElement',
        props: ['title', 'text'],
        data() {
            return {
                faqOpen: false
            }
        },
        methods: {
            faqToggleButton() {
                this.faqOpen = !this.faqOpen;
            }
        }
    }
</script>

<style scoped>
    .faq-element {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        margin-top: 10px;
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.04);
        border: 1px solid rgba(255, 255, 255, 0.08);
        transition: border-color 0.2s ease, background 0.2s ease;
    }

    .faq-element:first-of-type {
        margin-top: 0;
    }

    .faq-element.element-open {
        border-color: rgba(255, 255, 255, 0.15);
        background: rgba(255, 255, 255, 0.06);
    }

    .faq-element .button-toggle {
        width: 100%;
        min-height: 52px;
        padding: 14px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        text-align: left;
        font-size: 15px;
        font-weight: 600;
        color: #fff;
        background: transparent;
        border: none;
        cursor: pointer;
        transition: color 0.2s ease;
    }

    .faq-element .button-toggle:hover {
        color: #e5e7eb;
    }

    .faq-element .button-toggle:focus-visible {
        outline: 2px solid rgba(255, 255, 255, 0.5);
        outline-offset: 2px;
    }

    .faq-element .button-title {
        flex: 1;
        line-height: 1.4;
    }

    .faq-element .button-icon {
        flex-shrink: 0;
        fill: #9ca3af;
        transition: transform 0.25s ease, fill 0.2s ease;
    }

    .faq-element.element-open .button-icon {
        transform: rotate(180deg);
        fill: #fff;
    }

    .faq-element .element-text {
        width: 100%;
        padding: 0 16px 16px;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.6;
        color: #9ca3af;
    }
</style>